<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
      <LegalPerson ref="legalPerson" />
      <Company ref="company" />
      <Gps ref="gps" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import LegalPerson from './legalPerson';
import Company from './company';
import Gps from './gps';
import SubBtnBox from 'components/subBtnBox';
import {
  fleetEdit,
  fleetDetail,
} from 'api/getPay';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    LegalPerson,
    Company,
    Gps,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/getPay/account/company/edit',
      formComponents: ['baseForm', 'legalPerson', 'company', 'gps'],
      editParams: {
        tenantId: this.$route.query.id,
        showMoney: true,
      },
    };
  },
  computed: {
    detailParams () {
      return {
        customerId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: fleetDetail,
    editApi: fleetEdit,
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
